var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0H5.625C2.5184 0 0 2.5184 0 5.625V18.375C0 21.4816 2.5184 24 5.625 24H18.375C21.4816 24 24 21.4816 24 18.375V5.625C24 2.5184 21.4816 0 18.375 0Z",
    fill: "#023430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0475 10.0867C15.0596 5.72906 13.0009 4.569 12.4757 3.74897C12.259 3.38778 12.0671 3.01225 11.9015 2.625C11.8737 3.01219 11.8227 3.25594 11.4936 3.54956C10.833 4.13859 8.02705 6.42516 7.79089 11.3764C7.57086 15.9928 11.1846 18.8393 11.662 19.1336C12.0291 19.3143 12.4762 19.1375 12.6944 18.9716C14.4364 17.7761 16.8165 14.5888 16.0493 10.0867",
    fill: "#10AA50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0512 16.6753C11.9602 17.8179 11.8951 18.4819 11.6641 19.1348C11.6641 19.1348 11.8157 20.2226 11.9222 21.3749H12.2989C12.3889 20.5635 12.5262 19.758 12.7099 18.9625C12.2222 18.7225 12.0699 17.6779 12.0512 16.6753Z",
    fill: "#B8C4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7091 18.9634C12.2162 18.7356 12.0736 17.6691 12.0516 16.6755C12.1735 15.0365 12.209 13.3922 12.1581 11.7494C12.1323 10.8875 12.1703 3.76583 11.9458 2.72314C12.0993 3.07634 12.2763 3.41886 12.4756 3.74839C13.0008 4.56908 15.0602 5.72915 16.0474 10.0867C16.8164 14.5812 14.4492 17.7601 12.7091 18.9634Z",
    fill: "#12924F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.20ed6bd1d069d9af168c2ae825e50b1e.svg";
export { ForwardRef as ReactComponent };